export const DataSelect = {
    path: '/data_selects',
    name: 'data_selects',
    component: () => import('@/views/DataSelect/DataSelectPage.vue'),
    children: [
        {
            path: '/data_select/add',
            name: 'data_selects.add',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/data_select/edit/:id',
            name: 'data_selects.edit',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/data_select/delete/:id',
            name: 'data_selects.delete',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/data_select/view/:id',
            name: 'data_selects.view',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {viewAction: true}
        },
    ]
}